/* Risk reversal en el drawer de Rebuy (Mau, 2026-08-18; diseño B de la
   maqueta "Garantía bajo el checkout").

   Pinta una línea con escudo justo DEBAJO del botón de pagar, recordando
   la garantía que le corresponde a lo que hay en la cesta:

     Priority+ en la cesta ....... 100 días  (él es quien la amplía)
     Gel automático (= Protocolo Firmeza) ... 60 días
     Dispositivo suelto (= Kit Esencial) ....  30 días
     Ni dispositivo ni protocolo ... no se pinta nada

   Debajo de la línea van los LOGOS DE PAGO (Mau, 2026-08-24, misma
   estructura que ES): una sola imagen del theme con los métodos que sí
   existen en México (Visa, Mastercard, Amex, Kueski, SPEI, OXXO, PayPal).
   En ES esa fila la pinta Rebuy desde su admin (#smartcart-bottom-image);
   en MX ese ajuste está vacío, así que la inyecta este script y así vive
   en el theme (versionada) en vez de en la app.

   La jerarquía importa: si llevan Protocolo Y Priority+, mandan los 100.
   Y si en la cesta solo hay geles o accesorios no hay garantía de
   resultados que prometer, así que la línea no aparece en vez de
   inventarse una.

   Sobre el DOM: la cesta es Rebuy (app), su HTML lo pinta Vue y lo
   re-renderiza a su antojo, pero NO usa shadow DOM. Por eso aquí hay un
   MutationObserver: cada vez que Rebuy repinta el footer volvemos a
   colocar la línea. La inserción es idempotente — si ya está, solo se
   actualiza el texto.

   El contenido de la cesta se lee de /cart.js (la fuente de verdad de
   Shopify, no los títulos del DOM, que cambian con el idioma). */
(function () {
  'use strict';

  var CLASE = 'skd-garantia';
  var ESCUDO =
    '<svg class="skd-garantia__escudo" viewBox="0 0 24 24" aria-hidden="true">' +
    '<path d="M12 3l7 3v5.5c0 4.4-2.9 7.9-7 9.5-4.1-1.6-7-5.1-7-9.5V6z"/>' +
    '<path d="M9 12.2l2.1 2.1L15.4 10"/></svg>';

  /* Handles, no IDs de variante: sobreviven a que Mau duplique variantes. */

  /* ---- NIVELES MX (Mau, 2026-08-24: la oferta nueva los separa) -------
     La PDP promete literalmente "Exclusiva de Protocolo Firmeza. Con el
     Kit Esencial, la prueba es de 30 días", así que el drawer dice lo
     mismo que la tarjeta que eligió:

       Protocolo Firmeza -> 60. En MX el Protocolo NO es un producto: es
       dispositivo + gel automático, y ese gel (UNLISTED, solo entra desde
       la tarjeta Protocolo) es la señal limpia de que la compra es un
       Protocolo. Manda sobre el dispositivo.
       Kit Esencial -> 30 (dispositivo/kit suelto, sin gel automático).
       Priority+ ($190, handle garantia-express-premium) -> 100, gana
       siempre: su propio body promete "100 días de Garantía".

     Hasta hoy el dispositivo estaba cableado a 60 fijo (antes de la oferta
     nueva, cuando la promesa de marca era 60 para todo).
     -------------------------------------------------------------------- */
  var PRIORITY = 'garantia-express-premium';    // Skindion Priority+ (MX)
  var GEL_AUTO = 'gel-hidratante-200g-auto';    // = Protocolo Firmeza
  var PROTOCOLO = /^protocolo-skindion/;        // inerte en MX (existe en ES)
  /* El Kit Spa Facial (skindion-beauty-kit-*) es OTRO producto y su PDP
     sigue prometiendo 60 días: va en su propio tramo. El 30 aplica SOLO
     al dispositivo suelto (= Kit Esencial de la pdp-v2). */
  var KIT_SPA = /beauty-kit/;
  var DISPOSITIVO = /(^skindion-(rosa|negro)$)|^dispositivo-de-/;
  var NIVEL_DISPOSITIVO = 30;                   // Kit Esencial

  var NIVELES = {
    100: { texto: 'Garantía ampliada', dias: '100 días' },
    60:  { texto: 'Garantía de resultados', dias: '60 días' },
    30:  { texto: 'Devolución garantizada', dias: '30 días' }
  };

  var ultimoNivel = null;
  var pidiendo = false;

  /* La URL de la imagen se saca del src de ESTE script: el archivo vive en
     la misma carpeta /assets/ del theme, así que sobrevive a republicar el
     theme (cambia el /t/<n>/) sin hardcodear nada. currentScript hay que
     leerlo AHORA, en la ejecución síncrona del script: dentro de los
     callbacks ya vale null. */
  var PAGOS_IMG = (function () {
    var src = (document.currentScript && document.currentScript.src) || '';
    if (src.indexOf('/assets/') === -1) {
      var alt = document.querySelector('script[src*="js-rebuy-garantia"], link[href*="/assets/"]');
      src = alt ? (alt.src || alt.href || '') : '';
    }
    var i = src.indexOf('/assets/');
    return i === -1 ? '' : src.slice(0, i + 8) + 'payments-minicart.webp';
  })();

  /* Los métodos de pago, bajo la línea de garantía. Sin URL no se pinta
     nada (mejor eso que una caja vacía). Idempotente, como la garantía. */
  function colocarPagos() {
    var btn = document.querySelector('#rebuy-cart .rebuy-cart__checkout-button');
    if (!btn) return;
    var ancla = document.querySelector('#rebuy-cart .' + CLASE) || btn;
    var fila = document.querySelector('#rebuy-cart .skd-pagos');
    if (!fila) {
      fila = document.createElement('div');
      fila.className = 'skd-pagos';
      fila.setAttribute('role', 'img');
      fila.setAttribute('aria-label', 'Métodos de pago aceptados: Visa, Mastercard, American Express, Kueski Pay, SPEI, OXXO y PayPal');
      /* Sin URL derivada NO va inline style: el url() RELATIVO del CSS
         (resuelve contra /assets/) queda como fallback real. */
      if (PAGOS_IMG) fila.style.backgroundImage = 'url("' + PAGOS_IMG + '")';
    }
    if (fila.previousElementSibling !== ancla) ancla.insertAdjacentElement('afterend', fila);
  }

  function nivelDe(items) {
    var nivel = 0;
    for (var i = 0; i < items.length; i++) {
      var h = (items[i].handle || '').toLowerCase();
      if (h === PRIORITY) return 100;              // gana siempre
      if (h === GEL_AUTO) nivel = Math.max(nivel, 60);
      else if (PROTOCOLO.test(h)) nivel = Math.max(nivel, 60);
      else if (KIT_SPA.test(h)) nivel = Math.max(nivel, 60);
      else if (DISPOSITIVO.test(h)) nivel = Math.max(nivel, NIVEL_DISPOSITIVO);
    }
    return nivel;
  }

  function colocar(nivel) {
    var linea = document.querySelector('#rebuy-cart .' + CLASE);

    if (!nivel) {
      if (linea) linea.remove();
      return;
    }

    var btn = document.querySelector('#rebuy-cart .rebuy-cart__checkout-button');
    if (!btn) return;

    if (!linea) {
      linea = document.createElement('p');
      linea.className = CLASE;
      linea.innerHTML = ESCUDO + '<span></span>';
    }

    /* Idempotencia REAL: reescribir el span son mutaciones childList dentro
       de #rebuy-cart, que es justo lo que vigila nuestro MutationObserver.
       Sin este guard, cada repintado nuestro re-disparaba el observer ->
       bucle perpetuo a ~8 Hz + fetch continuo a /cart.js mientras hubiera
       algo con garantía en la cesta (cazado en el audit 2026-08-24; venía
       del archivo original del 08-18). El dataset no re-dispara: el
       observer no mira attributes. */
    if (linea.dataset.skdNivel !== String(nivel)) {
      var n = NIVELES[nivel];
      var span = linea.querySelector('span');
      span.textContent = '';
      span.appendChild(document.createTextNode(n.texto + ' '));
      var fuerte = document.createElement('strong');
      fuerte.textContent = n.dias;
      span.appendChild(fuerte);
      linea.dataset.skdNivel = String(nivel);
    }

    /* Justo después del botón (el "labio"); los logos de pago van debajo. */
    if (linea.previousElementSibling !== btn) btn.insertAdjacentElement('afterend', linea);
  }

  function refrescar() {
    if (pidiendo) return;
    pidiendo = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        ultimoNivel = nivelDe(cart.items || []);
        colocar(ultimoNivel);
        colocarPagos();
      })
      .catch(function () {})
      .then(function () { pidiendo = false; });
  }

  /* Rebuy repinta: recolocamos con lo que ya sabíamos (sin pedir la cesta
     otra vez) y, en paralelo, refrescamos por si cambió el contenido. */
  var pendiente = null;
  function alRepintar() {
    if (pendiente) return;
    pendiente = setTimeout(function () {
      pendiente = null;
      if (ultimoNivel !== null) colocar(ultimoNivel);
      colocarPagos();
      refrescar();
    }, 120);
  }

  var arrancado = false;
  function arrancar() {
    if (arrancado) return true;
    var raiz = document.getElementById('rebuy-cart');
    if (!raiz) return false;
    arrancado = true;
    document.removeEventListener('rebuy:smartcart.ready', arrancar);
    new MutationObserver(alRepintar).observe(raiz, { childList: true, subtree: true });
    refrescar();
    return true;
  }

  if (!arrancar()) {
    /* El contenedor de Rebuy aún no existe: se espera a su evento y, como
       red de seguridad, se vigila el body hasta que aparezca. */
    document.addEventListener('rebuy:smartcart.ready', arrancar);
    var vigia = new MutationObserver(function () {
      if (arrancar()) vigia.disconnect();
    });
    vigia.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('rebuy:cart.change', refrescar);
})();
